import { PolicyValidationResult } from '@policyvision/contracts';

import {
  ConfirmedValidationStatus,
  FrontendPolicyValidationResult,
} from '@/policy/contexts/ValidationContext';

const assembleStatus = (
  validation: ConfirmedValidationStatus,
): PolicyValidationResult['situations'][number] | null => {
  if (validation.status === 'NONE') return null;
  if (validation.status === 'ERROR' && validation.confirmed)
    return {
      identifier: validation.identifier,
      status: 'ERROR',
      description: validation.description,
    };
  if (validation.status === 'COHERENT')
    return { identifier: validation.identifier, status: 'COHERENT' };
  return null;
};

export const PolicyValidationAssembler = {
  assemblePolicyValidationResult: (
    validations: FrontendPolicyValidationResult,
  ): PolicyValidationResult => {
    const result: PolicyValidationResult = {
      situations: [],
      amendments: [],
      missingSections: [],
    };

    for (const validation of validations.situations) {
      const status = assembleStatus(validation);
      if (status) result.situations.push(status);
    }

    for (const validation of validations.amendments) {
      const status = assembleStatus(validation);
      if (status) result.amendments.push(status);
    }

    if (validations.policy) {
      const status = assembleStatus(validations.policy);
      if (status) result.policy = status;
    }

    if (validations.assignment) {
      const status = assembleStatus(validations.assignment);
      if (status) result.assignment = status;
    }

    for (const validation of validations.missingSections ?? []) {
      const status = assembleStatus(validation);
      if (status) result.missingSections?.push(status);
    }

    if (validations.financialData) {
      const status = assembleStatus(validations.financialData);
      if (status) result.financialData = status;
    }

    return result;
  },
};
